import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input, model } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { PropertyApplicationService } from '@workspace/data-types';
import { EtxeEnumsNiceLabelUtils } from '../../../../utils/etxe-enums-nice-label.utils';

export interface ServiceOptionItem {
  key: PropertyApplicationService;
  label: string;
  icon: string;
  description: string;
}

@Component({
  selector: 'etxe-property-application-services-selector',
  imports: [CommonModule, MatIconModule],
  templateUrl: './property-application-services-selector.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyApplicationServicesSelectorComponent {
  readonly services = model<PropertyApplicationService[]>([]);
  readonly title = input<string>('Engagements de service');
  readonly subtitle = input<string>("Prestations convenues à l'issue de la visite");

  readonly availableServices: ServiceOptionItem[] = [
    {
      key: PropertyApplicationService.PROFESSIONAL_PHOTOS,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.PROFESSIONAL_PHOTOS),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.PROFESSIONAL_PHOTOS),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.PROFESSIONAL_PHOTOS,
      ),
    },
    {
      key: PropertyApplicationService.VIRTUAL_TOUR_3D,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.VIRTUAL_TOUR_3D),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.VIRTUAL_TOUR_3D),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.VIRTUAL_TOUR_3D,
      ),
    },
    {
      key: PropertyApplicationService.FINANCIAL_SCREENING,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.FINANCIAL_SCREENING),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.FINANCIAL_SCREENING),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.FINANCIAL_SCREENING,
      ),
    },
    {
      key: PropertyApplicationService.ACTIVE_BUYER_POOL,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.ACTIVE_BUYER_POOL),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.ACTIVE_BUYER_POOL),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.ACTIVE_BUYER_POOL,
      ),
    },
    {
      key: PropertyApplicationService.PREMIUM_PORTALS,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.PREMIUM_PORTALS),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.PREMIUM_PORTALS),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.PREMIUM_PORTALS,
      ),
    },
    {
      key: PropertyApplicationService.REGULAR_REPORTING,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.REGULAR_REPORTING),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.REGULAR_REPORTING),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.REGULAR_REPORTING,
      ),
    },
    {
      key: PropertyApplicationService.DRONE,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.DRONE),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.DRONE),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(PropertyApplicationService.DRONE),
    },
    {
      key: PropertyApplicationService.HOME_STAGING,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.HOME_STAGING),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.HOME_STAGING),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.HOME_STAGING,
      ),
    },
    {
      key: PropertyApplicationService.SOCIAL_MEDIA_ADS,
      label: EtxeEnumsNiceLabelUtils.applicationService(PropertyApplicationService.SOCIAL_MEDIA_ADS),
      icon: EtxeEnumsNiceLabelUtils.applicationServiceIcon(PropertyApplicationService.SOCIAL_MEDIA_ADS),
      description: EtxeEnumsNiceLabelUtils.applicationServiceDescription(
        PropertyApplicationService.SOCIAL_MEDIA_ADS,
      ),
    },
  ];

  isServiceSelected(serviceKey: PropertyApplicationService): boolean {
    return (this.services() ?? []).includes(serviceKey);
  }

  toggleService(serviceKey: PropertyApplicationService): void {
    const current = this.services() ?? [];
    const updated = current.includes(serviceKey)
      ? current.filter((s) => s !== serviceKey)
      : [...current, serviceKey];
    this.services.set(updated);
  }
}
